import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';

//material ui components:
import { withStyles } from '@material-ui/core/styles';
import { Paper, Grid, Typography, TextField } from '@material-ui/core';

//actions:
import { modifyFieldOtrosDatos } from '../../../actions/cierre_diario_actions';
import {  setSaveState } from '../../../actions';

//components:
import IntNumberFormatInput from '../../../components/int_number_input_formatter';

//styles:
const styles = theme => ({
    container: {
        padding: 0,
        marginBottom: 5,
        fontSize: 13,
        fontWeight: '600',
        margin: '0 8px',
        borderBottom: '3px solid #b8b8b8',
        borderRight: '3px solid #b8b8b8',
        height: 155,
    },
    paperTitle: {
        fontSize: 13,
        fontWeight: '500',
        margin: 0,
        color: 'white',
        backgroundColor: theme.palette.primary.main,
        padding: '4px 2px 4px 12px',
    },
    containerItems: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        height: 130,
    },
    singleItem: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '2px 15px',
    },
    label: {
        maxWidth: 85,
        fontSize: 11,
    },
    input: {
        width: 60,
        [`& fieldset`]: {
            borderRadius: 0,
            borderColor: 'black !important'
        },
    },
    inputImporte: {
        textAlign: 'right',
        margin: '8px 8px 8px 2px',
        padding: 0,
        fontSize: 12,
    },
    textAreaContainer: {
        padding: '0 10px',
        height: '90%',
        marginTop: -10,
    },
    textareaInput: {
        display: 'flex',
        alignItems: 'start',
        padding: 5,
        height: 120,
        fontSize: 13,
        fontWeight: '500',
        backgroundColor: 'white',
        borderRadius: 0,
        [`& fieldset`]: {
            borderRadius: 0,
            borderColor: 'black !important',
            height: 'inherit',
        },
    },
});

class SecondRowPapers extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            //eventos, hechos relevantes:
            eventosRelevantes: !this.props.otrosDatosCierreDiario.eventosRelevantes ? '' : this.props.otrosDatosCierreDiario.eventosRelevantes,
            //rrhh:
            horasPersonal: !this.props.otrosDatosCierreDiario.horasPersonal ? 0 : this.props.otrosDatosCierreDiario.horasPersonal,
            horasVacaciones: !this.props.otrosDatosCierreDiario.horasVacaciones ? 0 : this.props.otrosDatosCierreDiario.horasVacaciones,
            horasBajas: !this.props.otrosDatosCierreDiario.horasBajas ? 0 : this.props.otrosDatosCierreDiario.horasBajas,
        };
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        //once we get the data:
        if (prevProps.otrosDatosCierreDiario !== this.props.otrosDatosCierreDiario) {
            this.setState({
                //eventos, hechos relevantes:
                eventosRelevantes: !this.props.otrosDatosCierreDiario.eventosRelevantes ? '' : this.props.otrosDatosCierreDiario.eventosRelevantes,
                //rrhh:
                horasPersonal: !this.props.otrosDatosCierreDiario.horasPersonal ? 0 : this.props.otrosDatosCierreDiario.horasPersonal,
                horasVacaciones: !this.props.otrosDatosCierreDiario.horasVacaciones ? 0 : this.props.otrosDatosCierreDiario.horasVacaciones,
                horasBajas: !this.props.otrosDatosCierreDiario.horasBajas ? 0 : this.props.otrosDatosCierreDiario.horasBajas,
            });
        };
    };


    handleValueChange = (event, field) => {

        this.setState({ ...this.state, [field]: event.target.value });
    };


    onBlur = (event, field) => {

        // const value = !event.target.value ? 0 : parseInt(event.target.value);

        this.props.setSaveState(true);
        this.props.modifyFieldOtrosDatos(field, this.state[field]);
    };

    onBlurText = (event, field) => {

        const value = !event.target.value ? '' : event.target.value;

        this.props.setSaveState(true);
        this.props.modifyFieldOtrosDatos(field, value);
    };

    render() {

        const { classes } = this.props;

        return (

            <Grid container style={{ marginBottom: 5, height: 155 }}>

                {/* eventos: */}
                <Grid item xs={8}>
                    <Paper className={classes.container} elevation={0}>
                        <h5 className={classes.paperTitle}>Eventos y hechos relevantes</h5>

                        <Grid container className={classes.textAreaContainer}>

                            <TextField
                                disabled={this.props.isDiaCerrado ? true : false}
                                placeholder={'Escriba aquí cualquier hecho relevante...'}
                                id={'eventosRelevantes'}
                                InputProps={{
                                    className: classes.textareaInput
                                }}
                                multiline
                                rowsMax="7"
                                margin="normal"
                                value={this.state.eventosRelevantes}
                                onChange={(event) => this.handleValueChange(event, 'eventosRelevantes')}
                                onBlur={(event) => this.onBlurText(event, 'eventosRelevantes')}
                                variant='outlined'
                                fullWidth
                            />
                        </Grid>

                    </Paper>
                </Grid>

                {/* hhrr: */}
                <Grid item xs={4}>
                    <Paper className={classes.container} elevation={0}>
                        <h5 className={classes.paperTitle}>RRHH</h5>

                        <div className={classes.containerItems}>
                            <div className={classes.singleItem} >
                                {/* first label and input*/}
                                <Typography variant="subtitle2" className={classes.label}>Horas Personal</Typography>

                                <TextField
                                    disabled={this.props.isDiaCerrado ? true : false}
                                    // placeholder={'0'}
                                    className={classes.input}
                                    id={'horasPersonal'}
                                    InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                                    value={this.state.horasPersonal}
                                    onChange={(event) => this.handleValueChange(event, 'horasPersonal')}
                                    onBlur={(event) => this.onBlur(event, 'horasPersonal')}
                                    variant='outlined'
                                />
                            </div>

                            <div className={classes.singleItem} >
                                {/* second label and input*/}
                                <Typography variant="subtitle2" className={classes.label}>Horas Vacaciones</Typography>

                                <TextField
                                    disabled={this.props.isDiaCerrado ? true : false}
                                    // placeholder={'0'}
                                    className={classes.input}
                                    id={'horasVacaciones'}
                                    InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                                    value={this.state.horasVacaciones}
                                    onChange={(event) => this.handleValueChange(event, 'horasVacaciones')}
                                    onBlur={(event) => this.onBlur(event, 'horasVacaciones')}
                                    variant='outlined'
                                />
                            </div>

                            <div className={classes.singleItem} >
                                {/* third label and input*/}
                                <Typography variant="subtitle2" className={classes.label}>Horas Bajas</Typography>

                                <TextField
                                    disabled={this.props.isDiaCerrado ? true : false}
                                    // placeholder={'0'}
                                    className={classes.input}
                                    id={'horasBajas'}
                                    InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                                    value={this.state.horasBajas}
                                    onChange={(event) => this.handleValueChange(event, 'horasBajas')}
                                    onBlur={(event) => this.onBlur(event, 'horasBajas')}
                                    variant='outlined'
                                />
                            </div>
                        </div>
                    </Paper>
                </Grid>
            </Grid>
        );
    };
};


SecondRowPapers.propTypes = {
    otrosDatosCierreDiario: PropTypes.object.isRequired,
    modifyFieldOtrosDatos: PropTypes.func.isRequired,
    isDiaCerrado: PropTypes.bool.isRequired,
};


function mapStateToProps(state) {
    return {
        otrosDatosCierreDiario: state.otrosDatosCierreDiario.datos,
        isDiaCerrado: state.centroDiaSelected.isDiaCerrado,
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        modifyFieldOtrosDatos,
        setSaveState
    }, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(SecondRowPapers));
